import { useEffect } from "react";
import { useTranslation } from "../i18n/LanguageContext";

// Right-side slide-in drawer. Closes on the ✕ button, backdrop click or Escape.
function Drawer({ open, title, onClose, footer, children }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative flex h-full w-full max-w-md flex-col border-l border-slate-700/70 bg-slate-800/97 shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-700/70 px-5 py-4">
          <h2 className="text-lg font-bold text-white">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-xl text-slate-300 transition hover:text-white"
            aria-label={t("drawer.close", "Close")}
          >
            ✕
          </button>
        </div>
        <div className="flex-1 space-y-4 overflow-y-auto px-5 py-4">{children}</div>
        {footer && <div className="border-t border-slate-700/70 px-5 py-4">{footer}</div>}
      </div>
    </div>
  );
}

export default Drawer;
